import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		// powerInfo:false,//当u_category为1或2，把普通用户查看里修改隐藏，所有充值里扣除隐藏uCategory==1 && uEnterpriseId ！=root 去掉
		safeInfo: {},
		loginInfo: {},
		authInfo: {},
		allProduct: [],
		mission: [],
		authProduct: [],
		allDisease: [],
		allPermission: [],
		allOrganization: [],
		appManager: [],
		appArticlePublisher: [],
		appArticleCategory: [{
			id: 1,
			name: '视频教学'
		}, {
			id: 2,
			name: '视觉科普'
		}, {
			id: 3,
			name: '案例集'
		}],
		allDeviceType: [{
			id: 1,
			name: '台车'
		}, {
			id: 2,
			name: 'pad'
		}, {
			id: 3,
			name: '大屏'
		}, {
			id: 4,
			name: '智慧检测屏'
		}],
		appSendStatus: [{
			id: 0,
			name: '未付款'
		}, {
			id: 1,
			name: '未发货'
		}, {
			id: 2,
			name: '已发货'
		}, {
			id: 3,
			name: '已收货'
		}, {
			id: 4,
			name: '已退货'
		}],
		appOrderStatus: [{
			id: 1,
			name: '待支付'
		}, {
			id: 2,
			name: '支付成功'
		}, {
			id: 3,
			name: '支付失败'
		}, {
			id: 4,
			name: '取消'
		}, {
			id: 5,
			name: '退款'
		}],
		appPayType: [{
			id: 1,
			name: '微信'
		}, {
			id: 2,
			name: '支付宝'
		}, {
			id: 3,
			name: '企业对公'
		}],
		allCard: [{
			id: 1,
			name: '专业版训练'
		}, {
			id: 0,
			name: '趣味版训练'
		}, {
			id: 1003,
			name: '专业版单眼'
		}, {
			id: 1004,
			name: '专业版双眼'
		}, {
			id: 1005,
			name: '趣味版单眼'
		}, {
			id: 1006,
			name: '趣味版双眼'
		}],
		cardState: [{
			id: 0,
			name: '售出'
		}, {
			id: 1,
			name: '赠送'
		}, {
			id: 2,
			name: '体验'
		}, {
			id: 3,
			name: '测试'
		}, {
			id: 4,
			name: '未出账'
		}],
		// allCard: [{
		// 	id: 601,
		// 	name: '近视防控卡'
		// }, {
		// 	id: 602,
		// 	name: '角塑伴侣卡'
		// }, {
		// 	id: 603,
		// 	name: '延缓老花卡'
		// }, {
		// 	id: 604,
		// 	name: '认知发育卡'
		// }, {
		// 	id: 605,
		// 	name: '缓解视疲劳卡'
		// }, {
		// 	id: 606,
		// 	name: '阅读障碍卡'
		// }, {
		// 	id: 607,
		// 	name: '斜弱视辅医卡'
		// }, {
		// 	id: 608,
		// 	name: '术后康复卡'
		// }, {
		// 	id: 611,
		// 	name: '趣味版(数字视保)'
		// }],
		allAgent: [],
		appTrainingProduct: [],
		iAssistantSortType: [{
			id: 1,
			label: '科普社区'
		}, {
			id: 2,
			label: '科飞课堂'
		}, {
			id: 3,
			label: '成功案列'
		}, {
			id: 4,
			label: '科普知识'
		}],
		iAssistantScienceType: [{
			id: 1,
			label: '视频'
		}, {
			id: 2,
			label: '图文'
		}],
		mallTrainingProduct: [],
		iAssistantIntegralProduct: [{
			id: 620,
			label: '成人弱视'
		}, {
			id: 621,
			label: '视疲劳'
		}]
	},
	getters: {
		powerInfo: state => {
			let {
				ucategory,
				uenterpriseId
			} = state.authInfo
			// console.log(state.authInfo);
			// let ucategory=3
			// let uenterpriseId='root'
			if (ucategory == '0' || (ucategory == 1 & uenterpriseId == 'root')) {
				return true;
			}
			return false;

		},
	},
	mutations: {
		setSafeInfo(state, safeInfo) {
			state.safeInfo = safeInfo;
		},
		setLoginInfo(state, loginInfo) {
			state.loginInfo = loginInfo;
		},
		setAuthInfo(state, authInfo) {
			state.authInfo = authInfo;
		},
		setAllProduct(state, allProduct) {
			state.allProduct = allProduct;
		},
		setMission(state, mission) {
			state.mission = mission;
		},
		setAuthProduct(state, authProduct) {
			state.authProduct = authProduct;
		},
		setAllDisease(state, allDisease) {
			state.allDisease = allDisease;
		},
		setAllPermission(state, allPermission) {
			state.allPermission = allPermission;
		},
		setAllOrganization(state, allOrganization) {
			state.allOrganization = allOrganization;
		},
		setAppManager(state, appManager) {
			state.appManager = appManager;
		},
		setAppArticlePublisher(state, appArticlePublisher) {
			state.appArticlePublisher = appArticlePublisher;
		},
		setAppTrainingProduct(state, appTrainingProduct) {
			state.appTrainingProduct = appTrainingProduct;
		},
		setMallTrainingProduct(state, mallTrainingProduct) {
			state.mallTrainingProduct = mallTrainingProduct;
		},
		setAllAgent(state, allAgent) {
			state.allAgent = allAgent;
		}
	}
})

export default store